import { ProjectService } from '@services/project.service';
import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumAPIStatus } from '@api/AbstractAPI';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

@Component({
    selector: 'app-associate-mygon',
    templateUrl: './associate-mygon.component.html',
    styleUrls: ['./associate-mygon.component.scss'],
})
export class AssociateMygonModalComponent {

    public Data: any[] = [];
    public CurrentAssociation: any | null = null;
    public SelectedItem: any | null = null;
    public TermsAccepted: boolean = false;

    private onAssociate: Function;
    private onDisassociate: Function;

    public Marketplace: any;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController,
        private ProjectService: ProjectService
    ) {
        this.Data = this.NavParams.get('data') || [];
        this.CurrentAssociation = this.NavParams.get('currentAssociation') || null;
        this.SelectedItem = this.CurrentAssociation;
        this.onAssociate = this.NavParams.get('onAssociate') || null;
        this.onDisassociate = this.NavParams.get('onDisassociate') || null;

        console.log(this.Data, this.CurrentAssociation);

        this.TermsAccepted = this.CurrentAssociation ? true : false;

        this.Marketplace = this.ProjectService.GetSettings()?.Configuration?.MarketPlace;

    }

    public get CanAssociate(): boolean {
        return !!this.SelectedItem && this.TermsAccepted;
    }

    public SelectItem(item: any): void {
        this.SelectedItem = this.SelectedItem?.IdExternal === item?.IdExternal ? null : item;
    }

    public async OnAssociate(): Promise<void> {
        if (!this.CanAssociate || !this.onAssociate) return;
        const result = await this.onAssociate(this.SelectedItem);
        if (result?.Status === EnumAPIStatus.Success)
            this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Confirm);
    }

    public async OnDisassociate(): Promise<void> {
        if (!this.onDisassociate) return;
        const result = await this.onDisassociate(this.CurrentAssociation);
        if (result?.Status === EnumAPIStatus.Success)
            this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Confirm);
    }

    public Close(): void {
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }
}
